import React from 'react';
import { IConfigContextProps } from '../../contexts/ConfigContext';
import Provider, { IAuthInitialState } from '../provider';
import CompleteSignup from './CompleteSignup';

export interface ILoginProps {
    configuration: IConfigContextProps;
    routing?: any;
    initialState?: IAuthInitialState;
}

const CompleteSignupContainer = ({
    configuration,
    routing,
    initialState,
}: ILoginProps) => {
    return (
        <Provider configuration={configuration} initialState={initialState}>
            <CompleteSignup routing={routing} />
        </Provider>
    );
};

export default CompleteSignupContainer;
